var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-qxu-c104": "",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sppiner-bg",
    d: "m64 32c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-56 0c0 13.255 10.745 24 24 24s24-10.745 24-24-10.745-24-24-24-24 10.745-24 24z",
    fill: "#EBF2FF",
    "_ngcontent-qxu-c104": ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "sppiner-principal",
    d: "m32 4c0-2.2091 1.7977-4.0258 3.9896-3.7503 2.8315 0.3558 5.6087 1.0895 8.2563 2.1862 3.8824 1.6082 7.41 3.9652 10.382 6.9367 2.9715 2.9715 5.3286 6.4991 6.9367 10.382 1.6082 3.8825 2.4359 8.0436 2.4359 12.246s-0.8277 8.3635-2.4359 12.246c-1.6081 3.8824-3.9652 7.4101-6.9367 10.382-2.9715 2.9715-6.4991 5.3286-10.382 6.9368-2.6475 1.0966-5.4247 1.8303-8.2562 2.1861-2.1919 0.2754-3.9896-1.5412-3.9896-3.7503s1.803-3.9661 3.9815-4.3326c1.7809-0.2996 3.5265-0.7999 5.2029-1.4943 2.9118-1.2061 5.5575-2.9739 7.7862-5.2025 2.2286-2.2286 3.9964-4.8744 5.2025-7.7862s1.8269-6.0327 1.8269-9.1844-0.6208-6.2726-1.8269-9.1844-2.9739-5.5576-5.2025-7.7862-4.8744-3.9964-7.7862-5.2025c-1.6763-0.69436-3.422-1.1947-5.2029-1.4943-2.1785-0.36649-3.9815-2.1234-3.9815-4.3326z",
    fill: "#3D5AFF",
    "_ngcontent-qxu-c104": ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.b91466c0ae26d80b2095df3150172948.svg";
export { ForwardRef as ReactComponent };